import React = require("react");
import {ReactNode} from "react";
import {MarketingConfig} from "../data/MarketingConfig";

import UnitOfMeasure = MarketingConfig.UnitOfMeasure;

interface UnitOfMeasureChangerProps {
    unitOfMeasure: UnitOfMeasure;
    options: SelectOption[];
    onUnitOfMeasureSelection: (unitOfMeasureName: string) => void;
}

export interface SelectOption {
    value: string;
    label: string;
}

/**
 * Component that allow the user to change data unit of measure.
 */
export class UnitOfMeasureChanger extends React.Component<UnitOfMeasureChangerProps, {}> {

    private static buildOption(option: SelectOption): ReactNode {
        return (
            <option value={option.value}>
                {option.label}
            </option>
        );
    }

    public render(): ReactNode {
        const options: SelectOption[] = this.props.options;
        if (options == null || options.length === 0) {
            return null;
        }
        const onChange = (event) => {
            this.props.onUnitOfMeasureSelection(event.target.value);
        };
        return (
            <div className="marketing-tab__unit-of-measure-changer">
                <select
                    onChange={onChange}
                    value={this.props.unitOfMeasure.code}
                >
                    {
                        options.map((opt: SelectOption) => (
                            UnitOfMeasureChanger.buildOption(opt)
                        ))
                    }
                </select>
            </div>
        );
    }
}
